import config from '../config';
import http from 'utils/http';

export async function getEtlFileLoad(params) {
  const url = config.endpoints.etlFileLoad;
  const { data } = await http.get(url, { params });

  return data;
}
